<template>
  <section>
      <div class="c-modal" :style="{display: show ? 'block' : 'none', 'z-index': 302}">
        <div class="c-modal__dialog c-modal__dialog--center">
            <!-- Modal content -->
            <div class="c-modal__content">
              <div class="c-modal__title center">
                ご確認ください
              </div>
              <div class="c-modal__body delivery">
                <div>
                  現在のリストの内容が削除されますが、よろしいですか？
                </div>
              </div>
              <div class="c-modal__buttons">
                <a href="javascript:void(0)" @click.prevent="confirmed" class="c-btn-close c-btn--no-arrow c-btn__red">削除する</a>
                <a href="javascript:void(0)" @click.prevent="completed" class="c-btn-close c-btn--no-arrow c-btn__red">リストへ戻る</a>
              </div>
            </div>
        </div>
      </div>
    </section>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { eventBus, Common } from "../common/common";

export default Vue.extend({
  name: 'confirm-reservation',
  props: ['closeModal', 'show', 'callback',"callbackComp"],
  data() {
    return {
      in_call: true
    }
  },
  created(){
    eventBus.$on("answerCall", function(){
      this.in_call = true;
    });
    eventBus.$on("endCall", function(){
      this.in_call = false;
    })
  },
  components: {
  },
  methods: {
    confirmed(){
      if (this.callback) {
        this.callback();
      }
      this.closeModal();
    },
    completed() {
      if (this.callbackComp) {
        this.callbackComp();
      }
      this.closeModal();
    },
    endCall(){
      Common.endCall();
    },
    nl2br(value) {
      return value?.replace(/\n/gi, "<br/>\n");
    }
  }
})
</script>